import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { RadarChart } from '@mui/x-charts/RadarChart';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function DemoRadarVisualisation(props) {
  const [hideMark, setHideMark] = React.useState(false);
  const [fillArea, setFillArea] = React.useState(true);

  const withOptions = (series) =>
    series.map((item) => ({ ...item, hideMark, fillArea }));

  let STR = props.STR;
  if(STR == null) { STR = 0}

  let INT = props.INT;
  if(INT == null) { INT = 0}

  let AGI = props.AGI;
  if(AGI == null) { AGI = 0}

  let VIT = props.VIT;
  if(VIT == null) { VIT = 0}

  let DEX = props.DEX;
  if(DEX == null) { DEX = 0}

  let LUK = props.LUK;
  if(LUK == null) { LUK = 0}

  let radarMaxValue = Math.max(...[STR, INT, AGI, VIT, DEX, LUK])

  return (
    <Box sx={{ height: '250px', width: '300px'}}>
          <RadarChart
            highlight="series"
            slotProps={{ tooltip: { trigger: 'item' } }}
            divisions={4}
            radar = {{ max: radarMaxValue, metrics: ['STR', 'INT', 'AGI', 'VIT', 'DEX', 'LUK']}}
            series={
                withOptions([{
                //label: 'Atributos',
                data: [STR, INT, AGI, VIT, DEX, LUK],
                hideMark: false,}])
            }
          />
    </Box>
  );
}

const commonSettings = {
  radar: {
    max: 100,
    metrics: ['STR', 'INT', 'AGI', 'VIT', 'DEX', 'LUK'],
  },
};

const bartGrades = {
  label: 'Bart',
  data: [25, 34, 51, 16, 90, 20],
  hideMark: false,
};